<template>
    <div class="automation-wizard-panel-footer">
        <CompassButton
            v-if="!hasFormSteps"
            :label="translations.activateAutomation"
            leftIcon="check"
            :loading="isLoading"
            @click="$emit('activate-automation')"
        />
        <template v-else>
            <CompassButton
                v-if="!isFirstStep"
                :label="translations.previous"
                type="tertiary"
                leftIcon="arrow-left"
                :disabled="isLoading"
                @click="$emit('previous-step')"
            />
            <CompassButton
                :label="nextButtonLabel"
                :leftIcon="isLastStep ? 'check' : ''"
                :loading="isLoading"
                @click="$emit('next-step')"
            />
        </template>
    </div>
</template>

<script>
const CONFIGURABLE_STEP_TYPES = ['trigger', 'action'];

export default {
    props: {
        allSteps: {
            type: Array,
            default: () => [],
        },
        currentStepIndex: {
            type: Number,
            default: 0,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['activate-automation', 'previous-step', 'next-step'],
    data() {
        return {
            translations: {
                activateAutomation: this.$t.__(
                    'automation.AutomationWizardPanelFooter.activate_automation',
                ),
                previous: this.$t.__('automation.AutomationWizardPanelFooter.previous'),
            },
        };
    },
    computed: {
        hasFormSteps() {
            return this.allSteps.some((step) => CONFIGURABLE_STEP_TYPES.includes(step.type));
        },
        isFirstStep() {
            return this.currentStepIndex === 0;
        },
        isLastStep() {
            return this.currentStepIndex === this.allSteps.length - 1;
        },
        remainingConfigSteps() {
            return this.allSteps
                .slice(this.currentStepIndex + 1)
                .filter((step) => CONFIGURABLE_STEP_TYPES.includes(step.type)).length;
        },
        nextButtonLabel() {
            if (this.isLastStep) {
                return this.translations.activateAutomation;
            } else {
                return this.$t.n__(
                    'automation.AutomationWizardPanelFooter.next_configure_steps',
                    null,
                    this.remainingConfigSteps,
                    this.remainingConfigSteps,
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-panel-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: var(--spacing-3) var(--spacing-4);
    gap: var(--spacing-3);
}
</style>
